import * as types from '../mutation-types'

import tahun from '@/helper/data-master/tahun'

// initial state
const state = {
  tahun: []
}

// getters
const getters = {
  tahun: state => state.tahun
}

// actions
const actions = {
  async getTahun ({ commit }) {
    try {
      let responseData = await tahun.get()
      commit(types.TAHUN_RECIEVE, { responseData })
    } catch (e) {
      // Tell the user if error happend
      console.log(e)
    }
  }
}

// mutations
const mutations = {
  [types.TAHUN_RECIEVE] (state, { responseData }) {
    state.tahun = responseData
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/tahun.js